import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'findLanguageFromKey',
	standalone: false,
})
export class FindLanguageFromKeyPipe implements PipeTransform {
	private languages: { [key: string]: { name: string; rtl?: boolean } } = {
		en: { name: 'English' },
		'pt-br': { name: 'Português' },
		es: { name: 'Español' },
		// jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
	};

	transform(lang: string): string {
		if (lang) {
			return this.languages[lang].name;
		}
		return lang;
	}
}
